var React = require('react');

function MenuItemActiveIco (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_32697","data-name":"Group 32697","transform":"translate(-181 -7121.461)"},[React.createElement("circle",{"id":"Ellipse_2711","data-name":"Ellipse 2711","cx":"3.904","cy":"3.904","r":"3.904","transform":"translate(181 7121.461)","fill":"#522ded","key":0}),React.createElement("rect",{"id":"Rectangle_2254","data-name":"Rectangle 2254","width":"39.043","height":"7.809","rx":"3.904","transform":"translate(192.713 7121.461)","fill":"#522ded","key":1})]));
}

MenuItemActiveIco.defaultProps = {"width":"50.755","height":"7.809","viewBox":"0 0 50.755 7.809"};

module.exports = MenuItemActiveIco;

MenuItemActiveIco.default = MenuItemActiveIco;
